export class AppRouteHelper {
	public static shellPartnersPrefix = 'partners';
	public static shellAdminPanelPrefix = 'cv';
	public static shellPrefix = '';
	public static hostPrefix = '';

	// shell routes
	public static home = 'home';
	public static dashboard = 'dashboard';
	public static computeExplorer = 'compute-explorer';
	public static commitmentManager = 'commitment-manager';
	public static commitmentManagerV2 = 'commitment-manager-v2';
	public static databaseExplorer = 'database-explorer';
	public static myOrganization = 'my-organization';
	public static accessTokens = 'access-tokens';
	public static dynamicContainers = 'dynamic-containers';
	public static unusedResources = 'unused-resources';
	public static anomalyDetection = 'anomaly-detection';
	public static s3 = 's3';
	public static rdsExplorer = 'rds-explorer';
	public static kompass = 'kompass';
	public static partnersPortal = 'partners';
	public static optimizationHub = 'optimization-hub';
	public static recommendations = 'recommendations';
	public static azureVm = 'azure-vm';
	public static audit = 'audit';
	public static riManager = 'ri-manager';
	public static riManagerList = 'list';
	public static listings = 'listings';
	public static rfVisualization = 'rf-visualization';
	public static settings = 'settings';
	public static userProfile = 'user-profile';
	public static disk = 'disk';
	public static notificationManagement = 'notification-management';
	public static slackIntegration = '/slack/integration';
	public static componentsOverview = 'components-overview';

	// control panel routes
	public static controlPanelOrganizations = 'cv/organizations';

	// partner shell routes
	public static partnersPortalOrganizations = 'organizations';
	public static partnersPortalAccounts = 'accounts';
	public static partnersPortalBillings = 'billings';
	public static partnersPortalReport = 'report';
	public static partnersPortalPRM = 'prm';

	// onboarding routes
	public static onboardAccount = 'onboard-account'; // new onboarding
	public static chooseProvider = 'choose-provider';
	public static aws = 'aws';
	public static azure = 'azure';
	public static verifyIntegration = 'verify-integration';
	public static queue = 'queue';
	public static accountId = ':accountId';
	public static accountIdPermissions = ':accountId/:permissions';
	public static accountIdUpdateLevel = ':accountId/update/:level';
	public static connectAccount = 'connect-account';
	public static setPermissions = 'set-permissions';
	public static completeSetup = 'complete-setup';

	// onboarding routes
	public static onboarding = 'onboarding';

	public static ssoSignIn = 'sso';
	public static notFound = '/404';
	public static error = 'error';
	public static forbidden = 'forbidden';

	public static defaultRoute = '/';
}
